export default {
      id: "attachment-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#attachment-usage",
      toString: function () {
        return this.url;
      }
    }